// Centralização de chaves usadas no localStorage
export const PRINT_TYPE_KEY = "wsw_print_type";
export const PRINTER_KEY = "wsw_selected_printer";
